import React from "react";
import { Footer, Head } from "..";

export const Layout = ({ children, title, ...others }) => {
  return (
    <>
      <Head title={title} />
      <main {...others}>
        <>{children}</>
      </main>
      <Footer />
    </>
  );
};
